import { Row, Col, Image, Card } from 'antd';
import logo from '../../assets/btm logo.png';

const AccountDeletionLayout = ({ children }) => (
  <Row justify="end" align="middle" style={{ flexDirection: 'column' }}>
    <Col>
      <Image
        style={{
          marginBottom: 10
        }}
        src={logo}
        width={350}
        preview={false}
      />
    </Col>
    <Card headStyle={{ textAlign: 'center' }} title="Διαγραφή λογαριασμού">
      {children}
    </Card>
  </Row>
);

export default AccountDeletionLayout;
